import { render, staticRenderFns } from "./save-button.vue?vue&type=template&id=5b483b0a&"
import script from "./save-button.component.ts?vue&type=script&lang=ts&"
export * from "./save-button.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports